import { Qualifiers } from "common/components/queryBuilder/qualifiers";

export const parseDisplayOptions = (value) => {
    const displayOptions = new Qualifiers({ value, whitelisted: ["view", "pivots", "section", "transferStatus"] });
    return {
        ...displayOptions.value.reduce((memo, { category }) => {
            const values = displayOptions.get(category);

            return {
                ...memo,
                [category]: category === "pivots" ? values : values.toString()
            };
        }, Object.create(null))
    };
};
